import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./ServiceConfirmFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useRef, useState } from "react";
import ServiceConfirmFormStepOne from "./ServiceConfirmFormSteps/ServiceConfirmFormStepOne";

const ServiceConfirmForm = (props) => {
  const theme = useTheme();
  const canvasDrawRef = useRef();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (!update) {
      setInitialValues({
        ..._initialValues
      });
      return;
    }
    if (update) {
      setInitialValues({
        ..._initialValues,
      });
      return;
    }

    setInitialValues({});
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit({ ...val, canvasDrawRef }, props)}
      validate={(val) => onValidate({ ...val, canvasDrawRef }, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="ServiceConfirmForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <ServiceConfirmFormStepOne {...formProps} {...props} canvasDrawRef={canvasDrawRef} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default ServiceConfirmForm;
